import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Modal, Row, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {
  allCustomerUsers,
  updateUser,
} from '../../pages/CustomerUsers/CustomerUsersSlice';
import { allCustomerInfos } from '../../pages/Customers/CustomersSlice';

const addUserSchema = yup.object().shape({
  name: yup.string(),
  email: yup
    .string()
    .required('Email is a required field.')
    .email('Invalid email format.'),
  power: yup.boolean(),
  mode: yup.boolean(),
  config: yup.boolean(),
  operation: yup.boolean(),
});

const ModalEditCustomerUsers = ({ show, setShow, userId, customerId }) => {
  const dataCustomerUsers = useSelector(allCustomerUsers);
  const token = localStorage.getItem('token');
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [validated, setValidated] = useState(false);
  const userInfo = dataCustomerUsers?.filter(
    (item) => item.id.id === userId
  )[0];
  const allCustomer = useSelector(allCustomerInfos);
  const customerInfo = allCustomer.data?.filter(
    (item) => item.id.id === customerId
  )[0];

  const handleClose = () => {
    clearErrors('email');
    setValidated(false);
    setShow(false);
  };

  const {
    register,
    setValue,
    clearErrors,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addUserSchema),
  });

  const onSubmit = () => {
    let name = getValues('name');
    let email = getValues('email');
    let power = getValues('power');
    let mode = getValues('mode');
    let config = getValues('config');
    let operation = getValues('operation');
    const tenantId = customerInfo.tenantId.id;

    dispatch(
      updateUser({
        token,
        userId,
        customerId,
        tenantId,
        name,
        email,
        mode,
        power,
        config,
        operation,
      })
    );
    setValidated(false);
    setShow(false);
  };

  useEffect(() => {
    if (show && !errors.email) {
      setValue('name', userInfo?.firstName);
      setValue('email', userInfo?.email);
      setValue('power', userInfo?.attributes?.role?.power);
      setValue('mode', userInfo?.attributes?.role?.mode);
      setValue('config', userInfo?.attributes?.role?.config);
      setValue('operation', userInfo?.attributes?.role?.operation);
    }
    if (errors.email) {
      setValidated(true);
    } else setValidated(false);
  }, [errors, show, setValue, userInfo]);

  useEffect(() => {
    if (errors.email) {
      setValidated(true);
    } else setValidated(false);
  }, [errors]);

  return (
    <Modal onHide={handleClose} size="lg" show={show}>
      <Modal.Header closeButton>
        <Modal.Title>{t('edit-user')}</Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="customerId">
                <Form.Label>{t('customer-id')}:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('customer-id')}
                  value={userId}
                  disabled
                />
              </Form.Group>
              <Form.Group as={Col} controlId="name">
                <Form.Label>{t('name')}:</Form.Label>
                <Form.Control
                  type="text"
                  placeholder={t('name')}
                  {...register('name')}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="email">
                <Form.Label>
                  <span>
                    <i
                      className="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('email')}:
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder={t('email')}
                  {...register('email')}
                />
                {errors.email && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.email.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="roles">
                <Form.Label>{t('role')}:</Form.Label>
                <Row>
                  <Col>
                    <Form.Group as={Col} controlId="power">
                      <Form.Label>{t('power')}:</Form.Label>
                      <label className="mode__switch" id="editUserSwitch">
                        <input
                          type="checkbox"
                          className="ml-2"
                          name="power"
                          {...register('power')}
                          defaultChecked={
                            userInfo?.attributes?.role?.power === 'true'
                              ? true
                              : false
                          }
                        />
                        <span className="mode__slider" id="editUser"></span>
                      </label>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="mode">
                      <Form.Label>{t('mode')}:</Form.Label>
                      <label className="mode__switch" id="editUserSwitch">
                        <input
                          type="checkbox"
                          className="ml-2"
                          name="mode"
                          {...register('mode')}
                          defaultChecked={
                            userInfo?.attributes?.role?.mode === 'true'
                              ? true
                              : false
                          }
                        />
                        <span className="mode__slider" id="editUser"></span>
                      </label>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="operation">
                      <Form.Label>{t('operation')}:</Form.Label>
                      <label className="mode__switch" id="editUserSwitch">
                        <input
                          type="checkbox"
                          className="ml-2"
                          name="operation"
                          {...register('operation')}
                          defaultChecked={
                            userInfo?.attributes?.role?.operation === 'true'
                              ? true
                              : false
                          }
                        />
                        <span className="mode__slider" id="editUser"></span>
                      </label>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group as={Col} controlId="config">
                      <Form.Label>{t('config')}:</Form.Label>
                      <label className="mode__switch" id="editUserSwitch">
                        <input
                          type="checkbox"
                          className="ml-2"
                          name="config"
                          {...register('config')}
                          defaultChecked={
                            userInfo?.attributes?.role?.config === 'true'
                              ? true
                              : false
                          }
                        />
                        <span className="mode__slider" id="editUser"></span>
                      </label>
                    </Form.Group>
                  </Col>
                </Row>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" type="submit">
            {t('update')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalEditCustomerUsers;
